import { Button } from "@blueprintjs/core"
import { useTranslation } from "react-i18next"

const ShowCurrentLocationButton = ({
  disabled,
  onClick,
  className = "absolute left-[10px] top-[80px] z-10",
}: {
  disabled: boolean
  onClick: () => void
  /** Placement; the default is the old fixed spot for maps without a column */
  className?: string
}) => {
  const { t } = useTranslation()
  return (
    <div className={className}>
      <Button
        id="show-current-location"
        disabled={disabled}
        onClick={onClick}
        icon="locate"
        className="dark:bg-gray-700 dark:text-white"
        title={t("maps.showCurrentLocationButton.title")}
      />
    </div>
  )
}

export default ShowCurrentLocationButton
